import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { ServicesComponent } from './services/services.component';
// import { EventsComponent } from './events/events.component';
import { HelpComponent } from './help/help.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { SharedModule } from '../shared/shared.module';
import { HttpModule } from '@angular/http';
import { FooterComponent } from './footer/footer.component';
import { UserOpinionComponent } from './user-opinion/user-opinion.component';
import { FormsModule } from '@angular/forms';
import { FeedbackApi } from '../api/api/FeedbackApi';
import { ZendeskChatComponent } from './zendesk-chat/zendesk-chat.component';
import { FreshdeskChatComponent } from './freshdesk-chat/freshdesk-chat.component';
import { LessonsComponent } from './lessons/lessons.component';
import { AllowPipe } from './menu/allow.pipe';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { ProgressbarService } from './progressbar/progressbar.service';
import { TranslateModule } from '@ngx-translate/core';
import { InfoBannersService } from '../shared/info-banners.service';
import { NotPaidTariffBannerComponent } from './not-paid-tariff-banner/not-paid-tariff-banner.component';
import { DiscountBannerComponent } from './discount-banner/discount-banner.component';
import { NumberCurryingPipe } from '../shared/number-currying.pipe';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		SharedModule,
		HttpModule,
		FormsModule,
		TranslateModule
	],
	declarations: [
		HeaderComponent,
		MenuComponent,
		ServicesComponent,
		// EventsComponent,
		HelpComponent,
		UserMenuComponent,
		FooterComponent,
		UserOpinionComponent,
		ZendeskChatComponent,
		FreshdeskChatComponent,
		LessonsComponent,
		AllowPipe,
		ProgressbarComponent,
		NotPaidTariffBannerComponent,
		DiscountBannerComponent
	],
	providers: [FeedbackApi, ProgressbarService, AllowPipe, InfoBannersService],

	exports: [
		HeaderComponent,
		FooterComponent,
		ZendeskChatComponent,
		FreshdeskChatComponent,
		ProgressbarComponent,
		NotPaidTariffBannerComponent,
		DiscountBannerComponent
	]
})
export class CoreModule { }



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/core.module.ts